'use strict';
accountSetupController.$inject = [
	'$scope',
	'$location',
	'dialogHelper',
	'$q',
	'$uibModal',
	'unitService',
	'accountStructureService',
	'accountCategoryService',
	'authService',
	'USER_CLAIMS',
];
angular.module('schoolLinqApp').controller('accountSetupController', accountSetupController);

function accountSetupController(
	$scope,
	$location,
	dialogHelper,
	$q,
	$uibModal,
	unitService,
	accountStructureService,
	accountCategoryService,
	authService,
	USER_CLAIMS
) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$q.all([$scope.vm.loadUnit($scope.vm), $scope.vm.loadAccountTypes($scope.vm), $scope.vm.loadCategories($scope.vm)]).then(function () {
		// When one of the pair of mask/map fields is set to valid or invalid,
		// the other should be set the same.
		$scope.$watch(
			'structureForm.assetAccountMask.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.assetElementMap.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.assetElementMap.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.assetAccountMask.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.liabilityAccountMask.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.liabilityElementMap.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.liabilityElementMap.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.liabilityAccountMask.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.expenseAccountMask.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.expenseElementMap.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.expenseElementMap.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.expenseAccountMask.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.revenueAccountMask.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.revenueElementMap.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.revenueElementMap.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.revenueAccountMask.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.reserveAccountMask.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.reserveElementMap.$setValidity('elementMap', mask);
			},
			true
		);

		$scope.$watch(
			'structureForm.reserveElementMap.$valid',
			function (mask) {
				$scope.structureForm.$setSubmitted();
				$scope.structureForm.reserveAccountMask.$setValidity('elementMap', mask);
			},
			true
		);

		if (viewModel.useNetAccounts) {
			$scope.$watch(
				'structureForm.netAccountMask.$valid',
				function (mask) {
					$scope.structureForm.$setSubmitted();
					$scope.structureForm.netElementMap.$setValidity('elementMap', mask);
				},
				true
			);

			$scope.$watch(
				'structureForm.netElementMap.$valid',
				function (mask) {
					$scope.structureForm.$setSubmitted();
					$scope.structureForm.netAccountMask.$setValidity('elementMap', mask);
				},
				true
			);
		}
	});

	function getViewModel() {
		var model = {
			unit: {
				SiteElement: null,
				FundElement: null,
			},
			backupUnit: null,
			accountStructure: null,
			backupAccountStructure: null,
			categories: [],
			subcategories: [],

			selectedCategory: null,

			filter: {
				tab: 'Structure',
				category: {
					search: '',
					propertyName: 'Category',
					reverse: false,
					startIndex: 0,
				},
				subcategory: {
					search: '',
					propertyName: 'Subcategory',
					reverse: false,
					startIndex: 0,
				},
			},
			pageSize: 10,
			errors: null,
			useNetAccounts: authService.authentication.useNetAccounts,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.system, 'AccountSetup', 'system'),
		};

		function formIsDirty() {
			return $scope.structureForm.$dirty || $scope.offsetsForm.$dirty;
		}

		function buildPatch(model) {
			var patch = _.pick(model.unit, function (value, key, object) {
				return model.unit[key] !== model.backupUnit[key];
			});
			return patch;
		}

		function changeTab(model, tab) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.filter.tab = tab;
			}
		}

		function save(model) {
			$scope.structureForm.$setSubmitted();
			$scope.offsetsForm.$setSubmitted();
			if (
				model.isReadOnly ||
				(!$scope.structureForm.$valid && model.filter.tab === 'Structure') ||
				(!$scope.offsetsForm.$valid && model.filter.tab === 'Offsets')
			)
				return false;
			if (model.filter.tab === 'Structure') {
				$scope.savingPromise = $q.all(
					accountStructureService.saveStructure(model.accountStructure).then(_.partial(finishSavingStructure, model)),
					unitService.saveUnit(model.unit).then(_.partial(finishSavingUnit, model))
				);
			} else {
				$scope.savingPromise = unitService.saveUnit(model.unit).then(_.partial(finishSavingUnit, model));
			}

			function finishSavingUnit(model, response) {
				if (response.data.isValid) {
					$scope.structureForm.$setPristine();
					$scope.offsetsForm.$setPristine();
					$scope.structureForm.$setUntouched();
					$scope.offsetsForm.$setUntouched();
					model.backupUnit = angular.copy(model.unit);
				} else {
					model.errors = response.data.errors;
				}
			}

			function finishSavingStructure(model, response) {
				if (response.data.isValid) {
					$scope.structureForm.$setPristine();
					$scope.offsetsForm.$setPristine();
					$scope.structureForm.$setUntouched();
					$scope.offsetsForm.$setUntouched();
					model.backupAccountStructure = angular.copy(model.accountStructure);
				} else {
					model.errors = response.data.errors;
				}
			}
		}

		function cancelSave(model) {
			$scope.structureForm.$setPristine();
			$scope.offsetsForm.$setPristine();
			$scope.structureForm.$setUntouched();
			$scope.offsetsForm.$setUntouched();
			model.unit = angular.copy(model.backupUnit);
			model.accountTypes = angular.copy(model.backupAccountTypes);
		}

		function loadUnit(model) {
			return unitService.getUnit().then(_.partial(finishLoadingUnit, model));

			function finishLoadingUnit(model, response) {
				model.unit = response.data.unit;
				model.backupUnit = angular.copy(model.unit);
				return angular.noop;
			}
		}

		function loadAccountTypes(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingStructure, model));

			function finishLoadingStructure(model, response) {
				model.accountStructure = response.data.accountStructure;
				model.backupAccountStructure = angular.copy(model.accountStructure);
				return angular.noop;
			}
		}

		function fundElements(model) {
			if (model.accountStructure) {
				let elements = _.intersection(
					model.accountStructure.AssetElementMap === null ? [] : model.accountStructure.AssetElementMap.split('.'),
					model.accountStructure.LiabilityElementMap === null ? [] : model.accountStructure.LiabilityElementMap.split('.'),
					model.accountStructure.ExpenseElementMap === null ? [] : model.accountStructure.ExpenseElementMap.split('.'),
					model.accountStructure.RevenueElementMap === null ? [] : model.accountStructure.RevenueElementMap.split('.'),
					model.accountStructure.ReserveElementMap === null ? [] : model.accountStructure.ReserveElementMap.split('.')
				);
				if (viewModel.useNetAccounts) {
					elements = _.intersection(
						elements,
						model.accountStructure.NetElementMap === null ? [] : model.accountStructure.NetElementMap.split('.')
					);
				}
				return _.filter(elements, function (element) {
					return element !== model.unit.SiteElement;
				});
			}
			return [];
		}

		function siteElements(model) {
			if (model.accountStructure) {
				let elements = _.intersection(
					model.accountStructure.AssetElementMap === null ? [] : model.accountStructure.AssetElementMap.split('.'),
					model.accountStructure.LiabilityElementMap === null ? [] : model.accountStructure.LiabilityElementMap.split('.'),
					model.accountStructure.ExpenseElementMap === null ? [] : model.accountStructure.ExpenseElementMap.split('.'),
					model.accountStructure.RevenueElementMap === null ? [] : model.accountStructure.RevenueElementMap.split('.'),
					model.accountStructure.ReserveElementMap === null ? [] : model.accountStructure.ReserveElementMap.split('.')
				);
				if (viewModel.useNetAccounts) {
					elements = _.intersection(
						elements,
						model.accountStructure.NetElementMap === null ? [] : model.accountStructure.NetElementMap.split('.')
					);
				}
				return _.filter(elements, function (element) {
					return element !== model.unit.FundElement;
				});
			}
			return [];
		}

		function loadCategoriesThenSelect(model, categoryId) {
			$scope.loadingPromise = accountCategoryService.getCategories().then(_.partial(finishLoadingCategories, model));

			function finishLoadingCategories(model, response) {
				model.categories = response.data.categories;
				let cat = _.filter(model.categories, function (categories) {
					return categories.Id === categoryId;
				});
				model.selectedCategory = cat[0];
				if (model.selectedCategory === null && model.categories.length > 0) {
					model.selectedCategory = model.categories[0];
				}
				model.loadSubcategories();
				return angular.noop;
			}
		}

		function loadCategories(model) {
			$scope.loadingPromise = accountCategoryService.getCategories().then(_.partial(finishLoadingCategories, model));

			function finishLoadingCategories(model, response) {
				model.categories = response.data.categories;
				if (model.selectedCategory === null && model.categories.length > 0) {
					model.selectedCategory = model.categories[0];
				}
				model.loadSubcategories();
				return angular.noop;
			}
		}

		function loadSubcategories(model) {
			if (model.selectedCategory === null) {
				model.subcategories.length = 0;
			} else {
				$scope.loadingPromise = accountCategoryService
					.getSubcategories(model.selectedCategory.Id)
					.then(_.partial(finishLoadingSubcategories, model));
			}

			function finishLoadingSubcategories(model, response) {
				model.subcategories = response.data.subcategories;
				return angular.noop;
			}
		}

		function selectCategory(model, category) {
			model.selectedCategory = category;
			loadSubcategories(model);
		}

		function changeCategoryPage(model) {
			model.selectedCategory = null;
			model.subcategories.length = 0;
		}

		function addCategory(model) {
			addOrEditCategory(model, 0);
		}

		function editCategory(model, id) {
			addOrEditCategory(model, id);
		}

		function addOrEditCategory(model, id) {
			if (id > 0) {
				model.addEditCategory = angular.copy(
					_.find(model.categories, function (category) {
						return category.Id === id;
					})
				);
			} else {
				model.addEditCategory = { Id: 0, Description: '' };
			}

			$uibModal
				.open({
					template: require('@ajs/templates/system/accountCategory-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'accountCategoryService',
						function ($scope, modalInstance, accountCategoryService) {
							model.errors = null;
							model.validationErrors = [];

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								save: function () {
									if (!$scope.addEditCategoryForm.$valid) return false;
									const duplicate = model.categories.find(
										(category) =>
											category.Description.toLowerCase() === model.addEditCategory.Description.toLowerCase() &&
											category.Id !== model.addEditCategory.Id
									);
									if (duplicate) {
										const message = [];
										message.push(`A category with the name "${duplicate.Description}" already exists!`);
										dialogHelper.openMessageBox('Account Category Error!', null, message, 'Warning');
									}
									if (model.addEditCategory.Id === 0) {
										$scope.savingPromise = accountCategoryService
											.addCategory(model.addEditCategory.Description)
											.then(_.partial(finishedSavingCategory, model));
									} else {
										$scope.savingPromise = accountCategoryService
											.updateCategory(model.addEditCategory.Id, model.addEditCategory.Description)
											.then(_.partial(finishedSavingCategory, model));
									}
									function finishedSavingCategory(model, response) {
										if (response.data.isValid) {
											modalInstance.close(response.data.Id);
										} else {
											model.addEditErrors = response.data.errors;
										}
									}
								},
								delete: function () {
									model.deleteCategory(id).then(function (didDelete) {
										if (didDelete) {
											modalInstance.close();
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (Id) {
					if (Id) {
						model.loadCategoriesThenSelect(Id);
					} else {
						model.loadCategories($scope.vm);
					}
				});
		}

		function deleteCategory(model) {
			return $uibModal.open({
				template: require('@ajs/templates/system/accountCategory-confirmdelete-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					'accountCategoryService',
					function ($scope, modalInstance, accountCategoryService) {
						model.errors = null;
						model.validationErrors = [];

						angular.extend($scope, {
							back: function () {
								modalInstance.close(false);
							},
							delete: function () {
								$scope.deletingPromise = accountCategoryService
									.deleteCategory(model.addEditCategory.Id)
									.then(_.partial(finishedDeletingCategory, model));

								return $scope.deletingPromise;

								function finishedDeletingCategory(model, response) {
									if (!response.data.isValid) {
										model.deleteErrors = response.data.errors;
									} else {
										modalInstance.close(true);
									}
								}
							},
						});
					},
				],
			}).result;
		}

		function addSubcategory(model) {
			if (model.selectedCategory !== null) addOrEditSubcategory(model, 0);
		}

		function editSubcategory(model, id) {
			addOrEditSubcategory(model, id);
		}

		function addOrEditSubcategory(model, id) {
			if (id > 0) {
				model.addEditSubcategory = angular.copy(
					_.find(model.subcategories, function (subcategory) {
						return subcategory.Id === id;
					})
				);
			} else {
				model.addEditSubcategory = { Id: 0, CategoryId: 0, Description: '' };
			}

			$uibModal
				.open({
					template: require('@ajs/templates/system/accountSubcategory-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'accountCategoryService',
						function ($scope, modalInstance, accountCategoryService) {
							model.errors = null;
							model.validationErrors = [];

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								save: function () {
									if (!$scope.addEditSubcategoryForm.$valid) return false;
									const duplicate = model.subcategories.find(
										(subcategory) =>
											subcategory.Description.toLowerCase() === model.addEditSubcategory.Description.toLowerCase() &&
											subcategory.Id !== model.addEditSubcategory.Id
									);
									if (duplicate) {
										const message = [];
										message.push(`A subcategory with the name "${duplicate.Description}" already exists!`);
										dialogHelper.openMessageBox('Account Category Error!', null, message, 'Warning');
									}
									if (model.addEditSubcategory.Id === 0)
										$scope.savingPromise = accountCategoryService
											.addSubcategory(model.selectedCategory.Id, model.addEditSubcategory.Description)
											.then(_.partial(finishedSavingSubcategory, model));
									else
										$scope.savingPromise = accountCategoryService
											.updateSubcategory(
												model.addEditSubcategory.Id,
												model.selectedCategory.Id,
												model.addEditSubcategory.Description
											)
											.then(_.partial(finishedSavingSubcategory, model));

									function finishedSavingSubcategory(model, response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											model.addEditErrors = response.data.errors;
										}
									}
								},
								delete: function () {
									model.deleteSubcategory(id).then(function (didDelete) {
										if (didDelete) {
											modalInstance.close(true);
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (reLoad) {
					if (reLoad) {
						model.loadSubcategories($scope.vm);
					}
				});
		}

		function deleteSubcategory(model) {
			return $uibModal.open({
				template: require('@ajs/templates/system/accountSubcategory-confirmdelete-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					'accountCategoryService',
					function ($scope, modalInstance, accountCategoryService) {
						model.errors = null;
						model.validationErrors = [];

						angular.extend($scope, {
							back: function () {
								modalInstance.close(false);
							},
							delete: function () {
								$scope.deletingPromise = accountCategoryService
									.deleteSubcategory(model.addEditSubcategory.Id)
									.then(_.partial(finishedDeletingSubcategory, model));

								return $scope.deletingPromise;

								function finishedDeletingSubcategory(model, response) {
									if (!response.data.isValid) {
										model.deleteErrors = response.data.errors;
									} else {
										modalInstance.close(true);
									}
								}
							},
						});
					},
				],
			}).result;
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			save: _.partial(save, model),
			cancelSave: _.partial(cancelSave, model),
			loadUnit: _.partial(loadUnit, model),
			loadAccountTypes: _.partial(loadAccountTypes, model),
			changeTab: _.partial(changeTab, model),
			fundElements: _.partial(fundElements, model),
			siteElements: _.partial(siteElements, model),
			loadCategoriesThenSelect: _.partial(loadCategoriesThenSelect, model),
			loadCategories: _.partial(loadCategories, model),
			loadSubcategories: _.partial(loadSubcategories, model),
			selectCategory: _.partial(selectCategory, model),
			addOrEditCategory: _.partial(addOrEditCategory, model),
			addCategory: _.partial(addCategory, model),
			editCategory: _.partial(editCategory, model),
			deleteCategory: _.partial(deleteCategory, model),
			addSubcategory: _.partial(addSubcategory, model),
			editSubcategory: _.partial(editSubcategory, model),
			addOrEditSubcategory: _.partial(addOrEditSubcategory, model),
			deleteSubcategory: _.partial(deleteSubcategory, model),
			changeCategoryPage: _.partial(changeCategoryPage, model),
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}
